import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import adminInfoService from './adminInfoService';
import { toast } from 'react-toastify';

const initialState = {
  info: null,
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: '',
};

// Get admin info
export const getAdminInfo = createAsyncThunk(
  'adminInfo/get',
  async (_, thunkAPI) => {
    try {
      return await adminInfoService.getAdminInfo();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Update admin info
export const updateAdminInfo = createAsyncThunk(
  'adminInfo/update',
  async (adminData, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.userInfo.token;
      if (!token) {
        return thunkAPI.rejectWithValue('Yetkilendirme başarısız. Lütfen tekrar giriş yapın.');
      }
      // DÜZELTME: Servisten dönen veriyi doğrudan döndürüyoruz.
      return await adminInfoService.updateAdminInfo(adminData, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      // DÜZELTME: .unwrap().catch() bloğunun hatayı yakalayabilmesi için rejectWithValue kullanıyoruz.
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Upload admin image
export const uploadAdminImage = createAsyncThunk(
  'adminInfo/uploadImage',
  async (uploadData, thunkAPI) => {
    try {
      // DÜZELTME: Diğer slice'larınızdaki gibi DOĞRU yoldan token'ı alıyoruz
      const token = thunkAPI.getState().auth.userInfo.token;
      
      // DÜZELTME: Token'ı servis fonksiyonuna iletiyoruz
      return await adminInfoService.uploadAdminImage(uploadData, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      toast.error(message);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const adminInfoSlice = createSlice({
  name: 'adminInfo',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAdminInfo.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAdminInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.info = action.payload;
      })
      .addCase(getAdminInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(updateAdminInfo.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAdminInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        // DÜZELTME: Başarı durumunu 'true' yapıyoruz.
        state.isSuccess = true;
        // Sayfalar başarı toast'ını bu mesaja bakarak gösteriyor. getAdminInfo
        // da isSuccess'i true yaptığı için sadece isSuccess'e bakmak her veri
        // çekilişinde "kaydedildi" demek olurdu; ayırt edici olan bu mesaj.
        state.message = 'update_success';
        // DÜZELTME: Gelen yeni veri ile 'info' state'ini güncelliyoruz.
        state.info = action.payload;
      })
      .addCase(updateAdminInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(uploadAdminImage.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(uploadAdminImage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.info = action.payload.updatedInfo;
        toast.success(action.payload.message);
      })
      .addCase(uploadAdminImage.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { reset } = adminInfoSlice.actions;
export default adminInfoSlice.reducer;